/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const latestTelemetry = /* GraphQL */ `
  query LatestTelemetry($device_id: ID!) {
    latestTelemetry(device_id: $device_id) {
      tenantKey
      device_id
      received_at
      tempC
      rh
      battV
      rssi
      ssid
      leak1
      leak2
      fw
      modelRev
      bootId
      uptime
      tilt
      magnitude
      __typename
    }
  }
`;
export const listTelemetry = /* GraphQL */ `
  query ListTelemetry($device_id: ID!, $since: AWSDateTime, $limit: Int) {
    listTelemetry(device_id: $device_id, since: $since, limit: $limit) {
      tenantKey
      device_id
      received_at
      tempC
      rh
      battV
      rssi
      ssid
      leak1
      leak2
      fw
      modelRev
      bootId
      uptime
      tilt
      magnitude
      __typename
    }
  }
`;
export const getDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      id
      tenantKey
      propertyId
      buildingId
      unitId
      propertyCode
      buildingCode
      unitCode
      room
      assetType
      isActive
      hierKey
      label
      notes
      lastTelemetryAt
      lastTelemetryAtEpoch
      lastBattV
      lowBatteryActive
      activeLeak
      leakStartedAt
      leakClearedAt
      tiltActive
      tiltConsecutiveCount
      tiltStartedAt
      tiltClearedAt
      healthStatus
      healthHierKey
      healthAssetHierKey
      claimedAt
      firstOnlineAt
      lastSsid
      lastRssi
      connectionCount
      lastBootId
      lastUptime
      lastBootAt
      rebootCount
      firmware
      modelRev
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDevices = /* GraphQL */ `
  query ListDevices(
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProperty = /* GraphQL */ `
  query GetProperty($id: ID!) {
    getProperty(id: $id) {
      id
      tenantKey
      code
      name
      address
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProperties = /* GraphQL */ `
  query ListProperties(
    $filter: ModelPropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProperties(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        code
        name
        address
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBuilding = /* GraphQL */ `
  query GetBuilding($id: ID!) {
    getBuilding(id: $id) {
      id
      tenantKey
      propertyId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBuildings = /* GraphQL */ `
  query ListBuildings(
    $filter: ModelBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        propertyId
        code
        name
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUnit = /* GraphQL */ `
  query GetUnit($id: ID!) {
    getUnit(id: $id) {
      id
      tenantKey
      propertyId
      buildingId
      code
      name
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUnits = /* GraphQL */ `
  query ListUnits(
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        code
        name
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      tenantKey
      deviceId
      type
      ts
      message
      deviceLabel
      data
      __typename
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        deviceId
        type
        ts
        message
        deviceLabel
        data
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvite = /* GraphQL */ `
  query GetInvite($id: ID!) {
    getInvite(id: $id) {
      id
      tenantKey
      code
      status
      emailLower
      expiresAt
      createdAt
      createdBySub
      acceptedAt
      acceptedBySub
      updatedAt
      __typename
    }
  }
`;
export const listInvites = /* GraphQL */ `
  query ListInvites(
    $filter: ModelInviteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        code
        status
        emailLower
        expiresAt
        createdAt
        createdBySub
        acceptedAt
        acceptedBySub
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTenant = /* GraphQL */ `
  query GetTenant($id: ID!) {
    getTenant(id: $id) {
      id
      name
      ownerUserSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTenants = /* GraphQL */ `
  query ListTenants(
    $filter: ModelTenantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTenants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        ownerUserSub
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      tenantKey
      userSub
      alertEmail
      phoneE164
      smsCriticalEnabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        userSub
        alertEmail
        phoneE164
        smsCriticalEnabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      tenantKey
      deviceId
      type
      severity
      openedAt
      lastNotifiedAt
      lastConfirmedAt
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantKey
        deviceId
        type
        severity
        openedAt
        lastNotifiedAt
        lastConfirmedAt
        title
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByTenantHierarchyTimeAll = /* GraphQL */ `
  query DevicesByTenantHierarchyTimeAll(
    $tenantKey: String!
    $hierKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByTenantHierarchyTimeAll(
      tenantKey: $tenantKey
      hierKey: $hierKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByTenantHierarchyTimeFiltered = /* GraphQL */ `
  query DevicesByTenantHierarchyTimeFiltered(
    $tenantKey: String!
    $assetTypeHierKey: ModelDeviceByTenantHierarchyTimeFilteredCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByTenantHierarchyTimeFiltered(
      tenantKey: $tenantKey
      assetTypeHierKey: $assetTypeHierKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByTenantCreatedAt = /* GraphQL */ `
  query DevicesByTenantCreatedAt(
    $tenantKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByTenantCreatedAt(
      tenantKey: $tenantKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByTenantLastTelemetryAtEpoch = /* GraphQL */ `
  query DevicesByTenantLastTelemetryAtEpoch(
    $tenantKey: String!
    $lastTelemetryAtEpoch: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByTenantLastTelemetryAtEpoch(
      tenantKey: $tenantKey
      lastTelemetryAtEpoch: $lastTelemetryAtEpoch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByTenantHealthHierKey = /* GraphQL */ `
  query DevicesByTenantHealthHierKey(
    $tenantKey: String!
    $healthHierKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByTenantHealthHierKey(
      tenantKey: $tenantKey
      healthHierKey: $healthHierKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByTenantHealthAssetHierKey = /* GraphQL */ `
  query DevicesByTenantHealthAssetHierKey(
    $tenantKey: String!
    $healthAssetHierKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByTenantHealthAssetHierKey(
      tenantKey: $tenantKey
      healthAssetHierKey: $healthAssetHierKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        unitId
        propertyCode
        buildingCode
        unitCode
        room
        assetType
        isActive
        hierKey
        label
        notes
        lastTelemetryAt
        lastTelemetryAtEpoch
        lastBattV
        lowBatteryActive
        activeLeak
        leakStartedAt
        leakClearedAt
        tiltActive
        tiltConsecutiveCount
        tiltStartedAt
        tiltClearedAt
        healthStatus
        healthHierKey
        healthAssetHierKey
        claimedAt
        firstOnlineAt
        lastSsid
        lastRssi
        connectionCount
        lastBootId
        lastUptime
        lastBootAt
        rebootCount
        firmware
        modelRev
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const propertiesByTenantName = /* GraphQL */ `
  query PropertiesByTenantName(
    $tenantKey: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    propertiesByTenantName(
      tenantKey: $tenantKey
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        code
        name
        address
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const propertiesByTenantCode = /* GraphQL */ `
  query PropertiesByTenantCode(
    $tenantKey: String!
    $code: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    propertiesByTenantCode(
      tenantKey: $tenantKey
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        code
        name
        address
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const buildingsByTenantPropertyCode = /* GraphQL */ `
  query BuildingsByTenantPropertyCode(
    $tenantKey: String!
    $propertyIdCode: ModelBuildingBuildingsByTenantPropertyCodeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBuildingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    buildingsByTenantPropertyCode(
      tenantKey: $tenantKey
      propertyIdCode: $propertyIdCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        code
        name
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitsByTenantBuildingCode = /* GraphQL */ `
  query UnitsByTenantBuildingCode(
    $tenantKey: String!
    $buildingIdCode: ModelUnitUnitsByTenantBuildingCodeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitsByTenantBuildingCode(
      tenantKey: $tenantKey
      buildingIdCode: $buildingIdCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        propertyId
        buildingId
        code
        name
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsByTenantTime = /* GraphQL */ `
  query EventsByTenantTime(
    $tenantKey: String!
    $ts: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsByTenantTime(
      tenantKey: $tenantKey
      ts: $ts
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        deviceId
        type
        ts
        message
        deviceLabel
        data
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsByTenantDeviceTime = /* GraphQL */ `
  query EventsByTenantDeviceTime(
    $tenantKey: String!
    $deviceIdTs: ModelEventEventsByTenantDeviceTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsByTenantDeviceTime(
      tenantKey: $tenantKey
      deviceIdTs: $deviceIdTs
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        deviceId
        type
        ts
        message
        deviceLabel
        data
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsByTenantTypeTime = /* GraphQL */ `
  query EventsByTenantTypeTime(
    $tenantKey: String!
    $typeTs: ModelEventEventsByTenantTypeTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsByTenantTypeTime(
      tenantKey: $tenantKey
      typeTs: $typeTs
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        deviceId
        type
        ts
        message
        deviceLabel
        data
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsByTenantDeviceTypeTime = /* GraphQL */ `
  query EventsByTenantDeviceTypeTime(
    $tenantKey: String!
    $deviceIdTypeTs: ModelEventEventsByTenantDeviceTypeTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsByTenantDeviceTypeTime(
      tenantKey: $tenantKey
      deviceIdTypeTs: $deviceIdTypeTs
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        deviceId
        type
        ts
        message
        deviceLabel
        data
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsByDeviceTime = /* GraphQL */ `
  query EventsByDeviceTime(
    $deviceId: ID!
    $ts: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsByDeviceTime(
      deviceId: $deviceId
      ts: $ts
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        deviceId
        type
        ts
        message
        deviceLabel
        data
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invitesByTenant = /* GraphQL */ `
  query InvitesByTenant(
    $tenantKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInviteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitesByTenant(
      tenantKey: $tenantKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        code
        status
        emailLower
        expiresAt
        createdAt
        createdBySub
        acceptedAt
        acceptedBySub
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invitesByCode = /* GraphQL */ `
  query InvitesByCode(
    $code: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInviteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitesByCode(
      code: $code
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        code
        status
        emailLower
        expiresAt
        createdAt
        createdBySub
        acceptedAt
        acceptedBySub
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userProfilesByTenant = /* GraphQL */ `
  query UserProfilesByTenant(
    $tenantKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userProfilesByTenant(
      tenantKey: $tenantKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        userSub
        alertEmail
        phoneE164
        smsCriticalEnabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByTenantLastNotified = /* GraphQL */ `
  query NotificationsByTenantLastNotified(
    $tenantKey: String!
    $lastNotifiedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByTenantLastNotified(
      tenantKey: $tenantKey
      lastNotifiedAt: $lastNotifiedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tenantKey
        deviceId
        type
        severity
        openedAt
        lastNotifiedAt
        lastConfirmedAt
        title
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
